module.exports = __webpack_public_path__ + "img/various-icon-d.581a899b.png";